import React from 'react';
import { Link } from 'react-router-dom';

const ForDesignersPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Для проектировщиков</h1>

      <div className="prose max-w-none">
        <p className="mb-6">
        "Теплогранд" предлагает комплексную поддержку проектировщикам и проектным организациям. Мы обеспечиваем всю необходимую техническую документацию и программное обеспечение для эффективной работы.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Поддержка проектировщиков</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-3">Техническая документация</h3>
            <ul className="list-disc pl-6">
              <li>Каталоги оборудования</li>
              <li>Технические описания</li>
              <li>BIM-модели</li>
            </ul>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-3">Программное обеспечение</h3>
            <ul className="list-disc pl-6">
              <li>Программы подбора</li>
              <li>Расчетные программы</li>
              <li>Библиотеки компонентов</li>
              <li>Обучающие материалы</li>
            </ul>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-3">Консультации</h3>
            <ul className="list-disc pl-6">
              <li>Технические консультации</li>
              <li>Помощь в подборе</li>
              <li>Проверка проектов</li>
              <li>Выезд на объект</li>
            </ul>
          </div>
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Обучение и сертификация</h2>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <ul className="list-disc pl-6">
            <li>Регулярные семинары и вебинары</li>
            <li>Практические занятия на оборудовании</li>
            <li>Доступ к базе знаний</li>
          </ul>
        </div>

        <div className="bg-gray-50 rounded-lg p-8 mt-8">
          <h2 className="text-2xl font-semibold mb-4">Начать сотрудничество</h2>
          <p className="mb-6">
          Для получения доступа к техническим материалам и программному обеспечению заполните форму регистрации или свяжитесь с нашим техническим отделом.
          </p>
          <Link 
            to="/callback"
            className="bg-primary text-white px-8 py-3 rounded-md hover:bg-primary-dark transition-colors"
          >
            Стать партнером
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForDesignersPage; 